export const calcAppendScript = () => {
    const script = document.createElement('script');
    script.src = "https://www.desmos.com/api/v1.5/calculator.js?apiKey=dcb31709b452b1cf9dc26972add0fda6";
    script.async = true;
    document.body.appendChild(script);
}